<template>
  <div id="firebaseui-auth-container" />
</template>

<script>
import {uiStart} from "@/firebase/auth.js";

export default {
  data: () => ({
  }),

  created: function() {
  },

  mounted() {
    uiStart('#firebaseui-auth-container');
  }
};
</script>
